import script from "./PersonalInfoStep4Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep4Mobile.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep4Mobile.vue?vue&type=style&index=0&id=8de6b66c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8de6b66c"]])

export default __exports__